import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const currentStockSlice = createApi({
    reducerPath: "currentStock",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        currentStock: builder.query({
            query: (data) => ({ url: "/inventory/api/v1/stock/list", params: data, method: "GET" }),
        }),
    }),
});

export const { useCurrentStockQuery } = currentStockSlice;
